import React from 'react';
import { SVGS } from '@zonofi/zono-money-design-system';
import './payment-header.scss';
import { useAppSelector } from '@zonofi/zono-money-helpers';
import {
  DateRangeState,
  dispatch,
  getCustomerInvite,
  updateIsSideDrawerOpen,
} from '@zonofi/zono-money-store';
import { DateRangeFilter } from '../date-range-filter/date-range-filter';

interface PaymentHeaderProps {
  showSearch: boolean;
  setShowSearch: (val: boolean) => any;
  searchKey: string;
  setSearchKey: (val: string) => any;
  showCategory: boolean;
  appliedDateRange: DateRangeState;
  applyNewDateRange: (dateRange?: DateRangeState) => void;
  openFiltersDrawer: (filterPage: string) => void;
}

export const PaymentHeader: React.FC<PaymentHeaderProps> = ({
  showSearch,
  setShowSearch,
  searchKey,
  setSearchKey,
  showCategory,
  appliedDateRange,
  applyNewDateRange,
  openFiltersDrawer,
}) => {
  const searchInputRef = React.useRef<HTMLInputElement>(null);
  const inviteData = useAppSelector(getCustomerInvite);
  const openDrawer = () => {
    dispatch(updateIsSideDrawerOpen(true));
  };
  if (showSearch) {
    return (
      <div
        className={`payment-header-search font-primary${
          !showCategory ? ' payment-header-category-not-visible' : ''
        }`}
      >
        <div className="payment-header-search-root">
          <img
            height={15}
            width={15}
            src={SVGS.LeftArrowBlack}
            alt="back"
            onClick={() => {
              setSearchKey('');
              setShowSearch(false);
            }}
          />
          <input
            className="payment-header-search-input font-primary-semibold"
            value={searchKey}
            placeholder="Search with Payment Id"
            autoFocus
            onChange={(e) => {
              setSearchKey(e?.target?.value);
            }}
            ref={searchInputRef}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                searchInputRef?.current?.blur();
              }
            }}
          />
          {searchKey?.length !== 0 && (
            <>
              <img
                src={SVGS.XCircle}
                alt="clear"
                onClick={() => {
                  setSearchKey('');
                }}
              />
              <div className="payment-header-search-root-divider" />
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div
      className={`payment-header font-primary${
        !showCategory ? ' payment-header-category-not-visible' : ''
      }`}
    >
      <div className="payment-header-contents">
        <div className="payment-header-seller">
          <div
            className="payment-header-seller-logo-container"
            onClick={openDrawer}
          >
            {inviteData?.seller?.profileImg ? (
              <img
                src={inviteData?.seller?.profileImg}
                className="payment-header-seller-logo-container-img"
              />
            ) : (
              <img src={SVGS.UserProfileIcon} />
            )}
          </div>
          <div className="payment-header-seller-info">
            <span className="payment-header-seller-info-name font-primary-semibold">
              {inviteData?.seller?.name}
            </span>
            <span className="payment-header-seller-info-subtitle font-primary">
              Payments
            </span>
          </div>
        </div>
        <div className="payment-header-options">
          <img
            src={SVGS.Search}
            alt="search"
            onClick={() => setShowSearch(true)}
          />
          <img
            src={SVGS.FiltersIcon}
            alt="filters"
            onClick={() => openFiltersDrawer('filters')}
          />
          <DateRangeFilter
            dateRange={appliedDateRange}
            setDateRange={(datesRange) => {
              applyNewDateRange(datesRange);
            }}
            handleCustomRange={() => {
              openFiltersDrawer('DateRange');
            }}
          />
        </div>
      </div>
    </div>
  );
};
